import React from "react";
import { AlphabeticListProps } from "./AlphabeticListProps";

const AlphabeticList: React.FC<AlphabeticListProps> = ({
    list
}) => {
    return (
        <React.Fragment>
            <div className="flex flex-row md:flex-row justify-center items-center w-full">
                <nav className="w-full">
                    <ul className="flex flex-wrap justify-center items-center gap-2 text-2xl text-blue-800 font-bold w-full">
                        {
                            list.map((value, index) => {
                                return (
                                    <li key={index}>
                                        <a href={`#${value}`}>{value}</a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </nav>
            </div>
        </React.Fragment>
    );    
};

export default AlphabeticList;